'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import * as embedActions from 'ContentData/actions/Embed';
import * as embedSelectors from 'ContentData/selectors/embeds';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { makeGetIsFieldCopyable } from 'DesignData/selectors/customWidgetBuffers';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.copySnippetButton.${key}`;

function makeMapStateToProps() {
  const getIsFieldCopyable = makeGetIsFieldCopyable();
  return (state, props) => {
    const fieldId = props.field && props.field.id;
    return {
      isFieldCopyable: getIsFieldCopyable(state, {
        fieldId,
        customWidgetId: props.customWidgetId
      }),
      hasFetchedMediaBridgeProviders: embedSelectors.getHasFetchedProviders(state),
      hasInstalledMediaBridgeProviders: embedSelectors.getMediaBridgeProviderOptions(state).length > 0
    };
  };
}

const mapDispatchToProps = {
  fetchMediaBridgeProviders: embedActions.fetchMediaBridgeProviders
};

class CopySnippetButton extends Component {
  componentDidMount() {
    if (this.props.field.type === FieldTypes.EMBED && this.props.useFullSnippet && !this.props.hasFetchedMediaBridgeProviders) {
      this.props.fetchMediaBridgeProviders();
    }
  }

  get copyValue() {
    const {
      contentTypes,
      fieldName,
      hostTemplateTypes,
      hasInstalledMediaBridgeProviders
    } = this.props;

    if (this.props.useFullSnippet) {
      return this.props.field.getModuleSnippet(fieldName, {
        contentTypes,
        hostTemplateTypes,
        hasInstalledMediaBridgeProviders
      });
    }

    return `{{ module.${fieldName} }}`;
  }

  render() {
    const {
      useFullSnippet,
      className,
      children,
      use,
      tooltipPlacement,
      disabled,
      isFieldCopyable
    } = this.props;
    let renderedChildren = useFullSnippet ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('label')
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('valueLabel')
    });

    if (children) {
      renderedChildren = children;
    }

    return /*#__PURE__*/_jsx(UICopyButton, {
      className: className,
      disabled: disabled || !isFieldCopyable,
      tooltipPlacement: tooltipPlacement,
      use: use,
      value: this.copyValue,
      children: renderedChildren
    });
  }

}

CopySnippetButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  contentTypes: PropTypes.array,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  hostTemplateTypes: PropTypes.array,
  isFieldCopyable: PropTypes.bool.isRequired,
  tooltipPlacement: PropTypes.string,
  use: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  useFullSnippet: PropTypes.bool,
  hasFetchedMediaBridgeProviders: PropTypes.bool,
  hasInstalledMediaBridgeProviders: PropTypes.bool,
  fetchMediaBridgeProviders: PropTypes.func.isRequired
};
CopySnippetButton.defaultProps = {
  className: null,
  children: null,
  tooltipPlacement: 'left',
  use: 'link',
  fieldName: '',
  disabled: false,
  useFullSnippet: true
};
export default connect(makeMapStateToProps, mapDispatchToProps)(CopySnippetButton);